import { render, staticRenderFns } from "./StudioWithdrawCard.vue?vue&type=template&id=6d0746b6&scoped=true"
import script from "./StudioWithdrawCard.vue?vue&type=script&lang=js"
export * from "./StudioWithdrawCard.vue?vue&type=script&lang=js"
import style0 from "./StudioWithdrawCard.vue?vue&type=style&index=0&id=6d0746b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0746b6",
  null
  
)

export default component.exports